var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkMore"},[_c('div',{staticClass:"btn",style:(_vm.sty),on:{"click":_vm.checkMore}},[_vm._v(" "+_vm._s(_vm.word)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }